import { memo } from "react";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import { FloatingDropZonesView } from "./FloatingDropZonesView";

export const FloatingDropZones = memo(() => {
  const dragAndDropType = useBuilderStore(state => state.dragAndDropType);

  if (dragAndDropType !== "floating-dropzones") return null;

  return <FloatingDropZonesView />;
});

FloatingDropZones.displayName = "FloatingDropZones";
